import ActionGroup from '../../../../../layout/forms/action-group';
import BackToAccountButton from '../../../../navigation/back-to-account-button';
import RichTranslation from '@blueshift-ui/i18n/dist/components/rich-translation';
import useTranslation from '@blueshift-ui/i18n/dist/hooks/use-translation';

function UpdateDiscard() {
  const { translate: richTranslate, loading: translationLoading } = useTranslation(
    'update_discard',
    { rich: true }
  );

  if (translationLoading) {
    return null;
  }

  return (
    <>
      <RichTranslation i18nKey="message" translator={richTranslate} />

      <ActionGroup>
        <BackToAccountButton />
      </ActionGroup>
    </>
  );
}

export default UpdateDiscard;
